<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button size="mini" type="primary" @click="search"> 搜索 </el-button>
        <el-button size="mini" @click="reset">重置</el-button>
        <el-button size="mini" type="primary" @click="showCreateModal = true">
          创建
        </el-button>
      </div>
    </customize-page>

    <el-dialog
      title="创建货主"
      :visible.sync="showCreateModal"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form :rules="rules" ref="form" :model="form">
        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type">
            <el-option value="NORMAL" label="非抖音"></el-option>
            <el-option value="DOUYIN" label="抖音"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货主名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="外部货主编号（抖音自营填写）" prop="outCustomerId">
          <el-input v-model="form.outCustomerId"></el-input>
        </el-form-item>
        <el-form-item label="货主ID(与WMS对应）" prop="customerId">
          <el-input v-model="form.customerId"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            @click="handleCreate"
            style="float: right"
            type="primary"
            >确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="编辑货主" :visible.sync="showUpdateModal" width="400px">
      <el-form :rules="rules" ref="updateForm" :model="updateForm">
        <el-form-item label="类型" prop="type">
          <el-select v-model="updateForm.type" disabled>
            <el-option value="NORMAL" label="电商类型"></el-option>
            <el-option value="DOUYIN" label="抖音"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货主名称" prop="name">
          <el-input v-model="updateForm.name"></el-input>
        </el-form-item>
        <el-form-item label="外部货主编码" prop="outCustomerId">
          <el-input v-model="updateForm.outCustomerId"></el-input>
        </el-form-item>
        <el-form-item label="货主id" prop="customerId">
          <el-input v-model="updateForm.customerId" disabled></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            @click="handleUpdateForm"
            style="float: right"
            type="primary"
            >确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import customerApi from "@/api/customer";

export default {
  components: {
    CustomizePage
  },
  mixins: [Page],
  created() {
    let initParam = this.$store.state.app.sc["customer"];
    if (initParam) {
      this.pagination.currentPage = initParam.request.pageIndex;
      this.pagination.pageSize = initParam.request.pageSize;
      this.filterObj = initParam.request.condition;
    }
  },
  mounted() {
    this.fetch();
  },
  data() {
    const includesBlank = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("货主id不能为空"));
      } else if (/\s+/g.test(value)) {
        callback(new Error("货主id不能有空格"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      dataList: [],
      showCreateModal: false,
      showUpdateModal: false,
      form: {},
      updateForm: {},
      columns: [
        {
          title: "货主类型",
          key: "type",
          align: "center",
          render: (h, params) => {
            const type = {
              NORMAL: "非抖音",
              DOUYIN: "抖音"
            };
            return <div>{type[params.row.type]}</div>;
          }
        },
        {
          title: "货主名称",
          key: "name",
          align: "center"
        },
        {
          title: "货主ID(与WMS对应）",
          key: "customerId",
          align: "center"
        },
        {
          title: "外部货主编号（抖音自营）",
          key: "outCustomerId",
          align: "center"
        },
        {
          title: "创建时间",
          key: "gmtCreate",
          align: "center"
        },
        {
          title: "操作",
          width: 200,
          align: "center",
          render: (h, param) => {
            let data = param.row;
            let operation = [
              <a
                type="text"
                style="color:blue"
                onClick={this.handleUpdate.bind(this, data)}
              >
                编辑
              </a>
            ];
            return operation;
          }
        }
      ],
      rules: {
        type: [{ required: true, message: "类型不能为空", trigger: "blur" }],
        customerId: [
          { required: true, message: "货主id不能为空", trigger: "blur" },
          { max: 20, message: "货主id长度不能超过20位", trigger: "blur" },
          { validator: includesBlank, trigger: "blur" }
        ],
        name: [{ required: true, message: "货主名称不能为空", trigger: "blur" }]
      },
      filterObj: {
        name: "",
        customerId: ""
      }
    };
  },
  methods: {
    handleCreate() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          customerApi
            .create({
              request: {
                ...this.form
              }
            })
            .then(res => {
              if (res.value) {
                this.$message.success("创建成功");
                this.form = {};
                this.showCreateModal = false;
                this.fetch();
              }
            });
        }
      });
    },
    handleUpdate(row) {
      console.log(row);
      this.updateForm = {
        id: row.id,
        type: row.type,
        customerId: row.customerId,
        outCustomerId: row.outCustomerId,
        name: row.name
      };
      this.showUpdateModal = true;
    },
    handleUpdateForm() {
      this.$refs["updateForm"].validate(valid => {
        if (valid) {
          customerApi
            .update({
              request: {
                ...this.updateForm
              }
            })
            .then(res => {
              if (res.value) {
                this.$message.success("更新成功");
                this.updateForm = {};
                this.showUpdateModal = false;
                this.fetch();
              }
            });
        }
      });
    },
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();

      let searchCondition = {
        request: {
          ...filterParams,
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        }
      };

      customerApi
        .pageQuery(searchCondition)
        .then(res => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.page || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch(error => {
          this.$message.error(error.msg || "未知错误");
        });
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },

    getFormConfig() {
      const type = this.getFormItemType();

      return [
        {
          data: [
            {
              label: "货主名称",
              model: "name",
              type: type.INPUT
            },
            {
              label: "货主id",
              model: "customerId",
              type: type.INPUT
            }
          ]
        }
      ];
    }
  }
};
</script>
